import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { INoteModel } from '@apps-common/types/management/note'

export const QUERY_GET_MANAGEMENT_NOTES = (entityId?: string) => ['getNotes', entityId].filter(Boolean)

export const getNotes = async (entityId: string): Promise<INoteModel[]> =>
  axios.get(`/management/note/getnotes?entityId=${entityId}`).then((res) => res.data?.data)

type QueryFnType = typeof getNotes

type Props = {
  config?: QueryConfig<QueryFnType>
  entityId: string
}

export const useManagementGetNotes = ({ config, entityId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_MANAGEMENT_NOTES(entityId),
    queryFn: () => getNotes(entityId)
  })
